import {
  Member,
  Benefit
} from '@td/membersupport';
import { get, upperFirst } from 'lodash';

function unmaskedPendingMember(member, restrictions) {
  return Member({
    memberId:       `elig_${get(member, 'mrnId')}`,
    defaultProfile: {
      benefits: [Benefit({
        mrnId: get(member, 'mrnId'),
        sponsor:           get(member, 'group.name'),
        hasWebAccess:      get(member, 'group.hasWebAccess'),
        canAccessOneapp:   get(member, 'group.oneAppFlag'),
        classification:    member.isPrimary ? 'Primary' : 'Dependent',
        isActive:          get(member, 'isActive'),
        healthPlanId:      get(member, 'sourceHealthPlanId') || get(member, 'sourceMrnId', 'N/A'),
        coverageStartDate: get(member, 'coverageStartDate'),
        coverageEndDate:   get(member, 'coverageEndDate'),
        products:          get(member, 'serviceSpecialties', []).map(product => get(product, 'displayName', '')),
        mrnSourceClassificationCd: get(member, 'mrnSourceClassificationCd'),
      })]
    },
    firstName:             get(member, 'firstName'),
    lastName:              get(member, 'lastName'),
    gender:                (get(member, 'gender') || '').substring(7).toLowerCase(),
    dob:                   get(member, 'dateOfBirth'),
    email:                 get(member, 'primaryEmailAddress'),
    phoneNumber:           get(member, 'phoneNumbers', []).map(p => p.internationalFormattedNumber).join(', '),
    city:                  get(member, 'addresses[0].city'),
    zipCode:               get(member, 'addresses[0].zipcode'),
    residentState:         get(member, 'addresses[0].state'),
    street:                `${get(member, 'addresses[0].addressLine1')} ${get(member, 'partyAddresses[0].addressLine2') || ''}`,
    registered:            restrictions.registered,
    canRegister:           get(member, 'isActive', false),
    groupRegistrationCode: get(member, 'groupRegistrationCode'),
    canResetPassword:      restrictions.canResetPassword,
    canImpersonate:        restrictions.canImpersonate,
    canViewProfileBtn:     restrictions.canViewProfileBtn,
    benefitToken:          get(member, 'benefitToken'),
    isRegistered:          get(member, 'isRegistered', false)
  });
}

export default unmaskedPendingMember;
